var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "view",
          rawName: "v-view",
          value: _vm.viewportEnter,
          expression: "viewportEnter",
        },
      ],
      staticClass: "rb-3d-carousel",
      class: "rb-editorial__bg-color--" + _vm.backgroundColor,
    },
    [
      _vm.skeletonIsVisible
        ? _c(
            "div",
            {
              ref: "imagesToLoad",
              staticClass: "rb-3d-carousel__images-to-load",
            },
            _vm._l(_vm.imagesToLoad, function (image, index) {
              return _c("img", { key: index, attrs: { "data-src": image } })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isTitleVisible
        ? _c(
            "div",
            { staticClass: "rb-3d-carousel__title" },
            [_vm._t("title")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.areTogglesVisible
        ? _c(
            "div",
            { staticClass: "rb-3d-carousel__toggles" },
            [
              _c(
                "rb-toggle-bar",
                _vm._l(_vm.numberOfToggles, function (_, index) {
                  return _c(
                    "rb-3d-toggle-provider",
                    {
                      key: index,
                      attrs: {
                        index: index,
                        "active-toggle": _vm.currentTabId,
                        "on-click": _vm.onToggleClick,
                        "skeleton-is-visible": _vm.skeletonIsVisible,
                      },
                    },
                    [_vm._t("toggles")],
                    2
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "slides",
          staticClass: "rb-3d-carousel__slides",
          class: { "rb-3d-carousel__slides--with-animation": !_vm.isLoading },
        },
        [
          _vm.skeletonIsVisible
            ? [
                _c(
                  "swiper",
                  {
                    ref: "swiperRef",
                    staticClass: "dynamic-carousel-container",
                    attrs: {
                      config: _vm.defaultConfig,
                      pagination: _vm.isMobile,
                      navigation: true,
                      "with-navigation-arrow": false,
                    },
                    on: { init: _vm.onInit },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "navigationprev",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.translation("swiper.previous"))
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "navigationnext",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.translation("swiper.next"))),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2783884745
                    ),
                  },
                  [
                    _c(
                      "rb-3d-dynamic-content",
                      {
                        attrs: {
                          "tab-id": _vm.currentTabId,
                          "background-color": _vm.backgroundColor,
                          "is-dummy-banner": true,
                        },
                      },
                      [_vm._t("banners")],
                      2
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "swiper",
                  {
                    ref: "swiperRef",
                    staticClass: "dynamic-carousel-container",
                    attrs: {
                      config: _vm.defaultConfig,
                      pagination: _vm.isMobile,
                      navigation: true,
                      "with-navigation-arrow": false,
                    },
                    on: {
                      init: _vm.onInit,
                      prev: _vm.addClickListenerOnActiveDuplicateSlide,
                      next: _vm.addClickListenerOnActiveDuplicateSlide,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "navigationprev",
                        fn: function () {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.translation("swiper.previous"))
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "navigationnext",
                        fn: function () {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.translation("swiper.next"))),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c(
                      "rb-3d-dynamic-content",
                      {
                        attrs: {
                          "tab-id": _vm.currentTabId,
                          "background-color": _vm.backgroundColor,
                        },
                      },
                      [_vm._t("banners")],
                      2
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }